import { BrandConfig } from '@oberoninternal/travelbase-website/dist/constants/brandConfig';

const brand = process.env.NEXT_PUBLIC_BRAND;

// eslint-disable-next-line import/no-dynamic-require
const travelbaseBrandConfig: BrandConfig = require(`./travelbaseBrandConfig.${brand}`).default;

export default travelbaseBrandConfig;
